import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Force service worker update check on load
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    // Check for updates immediately
    registration.update().catch(err => console.log('SW update check failed:', err));
    
    // Listen for new service worker
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New version available - reload the page
            console.log('New version available, reloading...');
            window.location.reload();
          }
        });
      }
    });
  }).catch(err => console.log('SW ready failed:', err));
  
  // Also listen for controlling service worker changes
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('Controller changed, reloading...');
    window.location.reload();
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
